<!--begin::User menu-->
<div class="app-navbar-item" id="kt_header_user_menu_toggle">
    <user-menu></user-menu>
</div>
<!--end::User menu-->